// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2fCh3","inner":"Footer_inner__2Tiy_","nextIcon":"Footer_nextIcon__aoZut","innerLeft":"Footer_innerLeft__1Vab7"};